import React from 'react';

function IconLink(props) {
   const {link, title, icon} = props;
   return (
    <div></div>
   );
}

export default IconLink;